var resolve = require("./resolve");
var request = require("./request");
var Promise = require("bluebird");
var config = require("./config");

exports.GetSearchPreferences = function() {
	return request
		.get(resolve(config.url(), "users/searchpreference"))
		.promise();
};

exports.UpdateSearchPreferences = function(data) {
	return request
		.put(resolve(config.url(), "users/searchpreference"), data)
		.promise();
};

exports.GetProfile = function(userId, viewname) {
	var last = "";
	if (viewname) last = "?viewName=" + viewname;

	if (userId) {
		last += "&userId=" + userId;
	}

	return request.get(resolve(config.url(), "users/profile" + last)).promise();
};

exports.GetProfileByReference = function(fundraiserRef, viewName) {
	var qry = {
		viewName: viewName
	};
	return request
		.get(
			resolve(
				config.url(),
				"users/profile/byFundraiserRef/" + fundraiserRef
			),
			qry
		)
		.promise();
};

exports.CreateProfile = function(data) {
	return request.post(resolve(config.url(), "users/profile"), data).promise();
};

exports.UpdateProfile = function(data) {
	return request.put(resolve(config.url(), "users/profile"), data).promise();
};

exports.UserExists = function(email) {
	return request
		.get(resolve(config.url(), "users/?email=" + encodeURIComponent(email)))
		.promise();
};

exports.CreateFundraisingProfile = function(applicationId) {
	return request
		.post(
			resolve(config.url(), "users/fundraisingprofile/" + applicationId)
		)
		.promise();
};

exports.UpdateFundraisingProfile = function(data) {
	return request
		.put(resolve(config.url(), "users/fundraisingprofile"), data)
		.promise();
};

exports.GetFundraisingProfile = function(id, viewname) {
	var qry = {
		viewName: viewname
	};
	return request
		.get(resolve(config.url(), "users/fundraisingprofile/" + id), qry)
		.promise();
};

exports.GetFundraisingProfileByReference = function(fundraiserRef, viewname) {
	var qry = {
		viewName: viewname
	};
	return request
		.get(
			resolve(
				config.url(),
				"users/fundraisingprofile/byFundraiserRef/" + fundraiserRef
			),
			qry
		)
		.promise();
};

exports.GetFundraiserProfile = function(id, viewname) {
	var qry = {
		viewName: viewname
	};
	return request
		.get(resolve(config.url(), "users/fundraiserprofile/" + id), qry)
		.promise();
};

exports.GetFundraisingProfiles = function(applicationId, viewname) {
	var qry = {
		applicationId: applicationId,
		viewName: viewname
	};
	return request
		.get(resolve(config.url(), "users/fundraisingprofile"), qry)
		.promise();
};

exports.JoinApplicationEvent = function(profileId, eventId) {
	return request
		.post(
			resolve(
				config.url(),
				"users/fundraisingprofile/" +
					profileId +
					"/joinevent/" +
					eventId
			)
		)
		.promise();
};

exports.LeaveApplicationEvent = function(profileId, eventId) {
	return request
		.delete(
			resolve(
				config.url(),
				"users/fundraisingprofile/" +
					profileId +
					"/leaveevent/" +
					eventId
			)
		)
		.promise();
};

exports.DeleteApplicationEvent = function(eventId) {
	return request
		.delete(resolve(config.url(), "applications/events/" + eventId))
		.promise();
};

exports.CreateApplicationEvent = function(applicationId, data) {
	return request
		.post(
			resolve(config.url(), "applications/" + applicationId + "/events"),
			data
		)
		.promise();
};

exports.EditApplicationEvent = function(applicationId, eventId, data) {
	return request
		.put(
			resolve(
				config.url(),
				"applications/" + applicationId + "/events/" + eventId
			),
			data
		)
		.promise();
};

exports.UpdateUserNumber = function(userId, number) {
	return request
		.put(resolve(config.url(), "users/" + userId + "/number"), {
			number: number
		})
		.promise();
};

exports.UpdateUserOrganisationPosition = function(
	userId,
	organisationPosition,
	displayOrganisationPosition
) {
	return request
		.put(
			resolve(config.url(), "users/" + userId + "/organisationPosition"),
			{
				organisationPosition: organisationPosition,
				displayOrganisationPosition: displayOrganisationPosition
			}
		)
		.promise();
};

exports.GetCurrentUserInformation = function() {
	return request
		.get(resolve(config.url(), "users/userinformation"))
		.promise();
};

exports.GetQuestions = function() {
	return request.get(resolve(config.url(), "users/gdprQuestions")).promise();
};

exports.UpdateGdprQuestions = function(req) {
	return request
		.put(resolve(config.url(), "users/gdprQuestions"), { answers: req })
		.promise();
};

exports.UpdateEmail = function(userId, newEmail) {
	const callbackUrl = resolve(config.baseUrl(), "/verify-email");
	const req = { callbackUrl: callbackUrl, newEmail: newEmail };
	return request
		.put(resolve(config.url(), "users/" + userId + "/email"), req)
		.promise();
};

exports.RemoveEmail = function(userId) {
	return request
		.put(resolve(config.url(), "users/" + userId + "/remove-update"), {})
		.promise();
};
